import {Component} from '@angular/core';
import {VoilaUserService} from '@services/voila-user.service';
import {User} from '@services/model/user';
import {Router, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {ToolbarComponent} from '@app/toolbar/toolbar.component';
import {HeaderComponent} from '@app/header/header.component';
import {MarkantElementsModule} from '@markant/elements-angular';
import {RouteBuilder} from '@util/route-builder';
import {CommonModule} from '@angular/common';
import {FreshdeskSupportComponent} from '@widgets/freshdesk-support/freshdesk-support.component';

@Component({
  selector: 'app-hp-dashboard',
  templateUrl: './hp-dashboard.component.html',
  styleUrls: ['./hp-dashboard.component.scss'],
  standalone: true,
  imports: [CommonModule, ToolbarComponent, HeaderComponent, MarkantElementsModule, RouterLink, RouterLinkActive, RouterOutlet, FreshdeskSupportComponent],
})
export class HpDashboardComponent {
  constructor(
    private readonly userService: VoilaUserService,
    private readonly router: Router,
  ) {}

  get title(): string {
    const u = this.userService.currentUser();
    if (!u) {
      return '';
    }
    if (u.title === 'Male') {
      return `Herzlich willkommen, Herr ${u.lastName}!`;
    } else if (u.title === 'Female') {
      return `Herzlich willkommen, Frau ${u.lastName}!`;
    } else {
      return `Herzlich willkommen, ${u.firstName} ${u.lastName}!`;
    }
  }

  get showAbstimmung(): boolean {
    return User.hasVotingPermission(this.userService.currentUser());
  }

  get routes() {
    return {
      welcome: RouteBuilder.app().hpDashboard().welcome().build(),
      voting: RouteBuilder.app().hpDashboard().voting().build(),
      products: RouteBuilder.app().hpDashboard().products().build(),
    };
  }

  pickedUrl(buttonName: string) {
    switch (buttonName.toLowerCase()) {
      case 'übersicht':
        if (this.router.url == this.routes.welcome) {
          return 'primary';
        } else {
          return 'secondary';
        }
      case 'abstimmung':
        if (this.router.url == this.routes.voting) {
          return 'primary';
        } else {
          return 'secondary';
        }
      case 'start-ups':
        if (this.router.url.includes(this.routes.products)) {
          return 'primary';
        } else {
          return 'secondary';
        }
    }
    return 'secondary';
  }
}
